import { render } from "./App.vue?vue&type=template&id=e1d9060a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e1d9060a&lang=less&scoped=true"

import exportComponent from "D:\\work_zfb\\zoudulaocheng\\web-zdlc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d9060a"]])

export default __exports__